import Section8 from './Section8'
export default Section8;